import { Component } from '@angular/core';
import {Events, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ApiForumProvider} from "../../providers/api-forum/api-forum";

/**
 * Generated class for the AppForumTopicCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-forum-topic-create',
  templateUrl: 'app-forum-topic-create.html',
})
export class AppForumTopicCreatePage {

  forum: any;
  editedTopic: any;
  topicName: string;
  topicText: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public apiForm: ApiForumProvider, public loading: LoadingController, public event: Events) {
    this.forum = this.navParams.data.forum;
    this.editedTopic = this.navParams.data.topic;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppForumTopicCreatePage');

    if(this.editedTopic) {
      this.topicName = this.editedTopic.title;
      this.topicText = this.editedTopic.description;
    }
  }

  createTopic() {
    if(!this.topicName || !this.topicText) {
      return ;
    }

    let loader = this.loading.create();
    loader.present();

    let payload: any = {};
    payload.title = this.topicName;
    payload.description = this.topicText;
    payload.id = this.editedTopic?this.editedTopic.id:null;

    this.apiForm.createTopic(this.forum.id, payload).then(_response => {

      if(this.editedTopic) {
        this.editedTopic.title = this.topicName;
        this.editedTopic.description = this.topicText;
      } else {
        _response.forumId = this.forum.id;
        this.event.publish('app:new-topic-created', {topic: _response})
      }

      // this.topic.posts.unshift(_response);
      // this.topic.responseCount++;
      this.navCtrl.pop();
      loader.dismissAll();
    });

  }


}



// WEBPACK FOOTER //
// ./src/pages/app-forum-topic-create/app-forum-topic-create.ts